import { Message } from 'antd';
import { useEffect, useState } from 'react';
import SendRewardModal from '../../presentation/sendRewardModal/SendRewardModal.jsx';
import {
	REVERSE_MAPING_BADGE_TYPE,
	ICON_COMPLETE_MAP,
} from '../../../RnRCommonComponent/CoreBadge/rewardsConstants';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { useSelector } from 'react-redux';

const SendRewardContainer = (props) => {
	const {
		checkAllEligibility,
		setSendRewardObject,
		sendRewardObject,
		setIsOpenRewardModel,
		handleSendShoutout = () => console.log('On Feed, did not auto-send.'),
	} = props;
	const [employeeData, setEmployeeData] = useState();
	const [badgeDetailObject, setBagdeDetailObject] = useState({});
	const [badgeData, setBadgeData] = useState();
	const [isBadgeLoading, setIsBadgeLoading] = useState(false);
	const [errorObject, setErrorObject] = useState({});
	const [rewardsAvailable, setRewardsAvailable] = useState(true);

	const currentUser = useSelector((state) => state.user.currentUser);

	const QUERY_BADGES_BY_COMPANY_ID = gql`
		query QueryBadgesByCompanyIdIndex(
			$companyId: ID!
			$limit: Int
			$nextToken: String
		) {
			queryBadgesByCompanyIdIndex(
				companyId: $companyId
				limit: $limit
				nextToken: $nextToken
			) {
				items {
					id
					companyId
					badgeTypeId
					assignmentSSORequiredId
					recipientPayTypeId
					recipientSSORequiredId
					physicalAwardActivityId
					iconId
					snappyGrantId
					snappyGrant {
						id
						externalSnappyId
						snappyCampaignId
						name
						description
						costInCurrency
					}
					name
					label
					description
					image
					color
					gradientColor
					points
					bonusPoints
					rewardBonus
					rewardMaxBonus
					assignmentLimit
					assignmentLevelId
					recipientLevelId
					isPreApproved
					isRewardRequiresDate
					visibility
					isAssignmentSSORequired
					isRecipientSSORequired
					automationRule
					externalWorkFlowId
					isAssignmentRestricted
					shape
					category
					customImageKey
					customImageSignedUrl
					badgeRotation
					labelColor
					customIconKey
					customIconSignedUrl
				}
				nextToken
			}
		}
	`;

	const getAllBadgeList = async () => {
		try {
			setIsBadgeLoading(true);

			const companyId = currentUser?.companyId || currentUser?.company?.id;

			if (!companyId) {
				console.error('Company ID not found');
				setIsBadgeLoading(false);
				return;
			}

			let allBadges = [];
			let nextToken = null;
			let hasMoreData = true;

			while (hasMoreData) {
				const { data, error } = await props.client.query({
					query: QUERY_BADGES_BY_COMPANY_ID,
					variables: {
						companyId: companyId,
						limit: 100,
						nextToken: nextToken,
					},
					fetchPolicy: 'network-only',
				});

				if (error) {
					console.error('Error fetching badges by company ID:', error);
					setIsBadgeLoading(false);
					return;
				}

				if (data?.queryBadgesByCompanyIdIndex?.items) {
					allBadges = [...allBadges, ...data.queryBadgesByCompanyIdIndex.items];

					nextToken = data.queryBadgesByCompanyIdIndex.nextToken;
					hasMoreData = !!nextToken;
				} else {
					hasMoreData = false;
				}
			}

			if (allBadges.length > 0) {
				const enrichedBadges = allBadges.map((badge) => {
					const badgeTypeCode =
						REVERSE_MAPING_BADGE_TYPE[badge.badgeTypeId] || '';

					let iconInfo = null;
					let iconCode = null;
					if (badge.iconId) {
						iconInfo = ICON_COMPLETE_MAP.find(
							(icon) => icon.id === badge.iconId
						);
						iconCode = iconInfo?.code;
					}

					return {
						...badge,
						badgeType: badgeTypeCode,
						badgeTypeCode: badgeTypeCode,
						iconInfo,
						iconCode,
					};
				});

				const filteredBadges = enrichedBadges.filter((badge) => {
					const matchesType = badge.badgeType === 'PEERTOPEER';
					const isVisible = badge.visibility !== false;

					const isRoleAllowed =
						!badge.isAssignmentRestricted ||
						['manager', 'admin', 'superAdmin'].includes(currentUser?.role);

					return matchesType && isVisible && isRoleAllowed;
				});

				setBadgeData(filteredBadges);
				const rewardsExist = filteredBadges.length > 0;
				setRewardsAvailable(rewardsExist);
			}
		} catch (error) {
			console.error('Error fetching badges:', error);
			Message.error('Failed to fetch recognitions list! Try again later.');
		} finally {
			setIsBadgeLoading(false);
		}
	};

	const fetchInitialData = () => {
		setIsBadgeLoading(true);
		getAllBadgeList();
	};

	useEffect(() => {
		fetchInitialData();
	}, []);

	return (
		<>
			<SendRewardModal
				currentUser={currentUser}
				badgeDetailObject={badgeDetailObject}
				setBagdeDetailObject={setBagdeDetailObject}
				setIsOpenRewardModel={setIsOpenRewardModel}
				sendRewardObject={sendRewardObject}
				setSendRewardObject={setSendRewardObject}
				checkAllEligibility={checkAllEligibility}
				employeeData={employeeData}
				badgeData={badgeData}
				isBadgeLoading={isBadgeLoading}
				setIsBadgeLoading={setIsBadgeLoading}
				setEmployeeData={setEmployeeData}
				errorObject={errorObject}
				setErrorObject={setErrorObject}
				rewardsAvailable={rewardsAvailable}
				handleSendShoutout={handleSendShoutout}
			/>
		</>
	);
};

export default withApollo(SendRewardContainer);
